import React from 'react';

import FullPageScroll from '../components/FullPageScroll';
import IntroRollingBg from './IntroRollingBg';
import Banner from './Banner';
import {bannerLobby, bannerLounge, bannerPrivateroom } from "../assets/data/bannerData"

const Intro = () => {

  return (
    <div className="mainWrap">
      <FullPageScroll>
        <IntroRollingBg />
        <Banner
          classType={bannerLobby.classType}
          title={bannerLobby.title}
          titleSrcPc={bannerLobby.titleSrcPc}
          titleSrcTab={bannerLobby.titleSrcTab}
          titleSrcMo={bannerLobby.titleSrcMo}
          unionSrc={bannerLobby.unionSrc}
          description1={bannerLobby.description1}
          description2={bannerLobby.description2}
          linkDesc={bannerLobby.linkDesc}
          link={bannerLobby.link}
        />
        <Banner
          classType={bannerLounge.classType}
          title={bannerLounge.title}
          titleSrcPc={bannerLounge.titleSrcPc}
          titleSrcTab={bannerLounge.titleSrcTab}
          titleSrcMo={bannerLounge.titleSrcMo}
          unionSrc={bannerLounge.unionSrc}
          description1={bannerLounge.description1}
          description2={bannerLounge.description2}
          linkDesc={bannerLounge.linkDesc}
          link={bannerLounge.link}
        />
        <Banner
          classType={bannerPrivateroom.classType}
          title={bannerPrivateroom.title}
          titleSrcPc={bannerPrivateroom.titleSrcPc}
          titleSrcTab={bannerPrivateroom.titleSrcTab}
          titleSrcMo={bannerPrivateroom.titleSrcMo}
          unionSrc={bannerPrivateroom.unionSrc}
          description1={bannerPrivateroom.description1}
          description2={bannerPrivateroom.description2}
          linkDesc={bannerPrivateroom.linkDesc}
          link={bannerPrivateroom.link}
        />
      </FullPageScroll>
    </div>
  )
}

export default Intro;